import { StepNavigationSwitch } from '../../atoms/step-navigation-switch';
import { SelectGenericNavigation } from './navigation/select-generic-navigation';
import { SelectInsertNavigation } from './navigation/select-insert-navigation';
import { SelectBody } from './select-body';

export const SelectNavigationSwitch = () => {
  return <StepNavigationSwitch generic={SelectGenericNavigation} insert={SelectInsertNavigation} body={SelectBody} />;
};
